<script setup lang="ts">
const bookerTarget = inject<HTMLElement>('bookerTarget', ref(null))
const isTopBarVisible = inject<Ref<boolean>>('isTopBarVisible', ref(false))

const { bottom } = useElementBounding(bookerTarget)

const isVisibleAnimation = inject<Ref<boolean>>('isNavBookerVisible', ref(false))

const stickyRef = ref<HTMLElement | null>(null)
const { height: stickyHeight } = useElementSize(stickyRef, undefined, { box: 'border-box' })

const SHOW_AT = 100

const isVisible = ref(false)

watch(
	[bottom, stickyHeight],
	([newBottom, newHeight]) => {
		if (!isVisible.value && newBottom < SHOW_AT) isVisible.value = true
		else if (isVisible.value && newBottom > SHOW_AT + newHeight) isVisible.value = false
	},
	{ immediate: true },
)

// some hacky way to enable animation without interfering with booker end location getBoundingClientRect
watch(
	() => isVisible.value,
	(newValue, oldValue) => {
		if (!newValue && oldValue) {
			setTimeout(() => {
				if (isVisibleAnimation) isVisibleAnimation.value = isVisible.value
			}, 500)
		} else if (isVisibleAnimation) isVisibleAnimation.value = newValue
	},
)
</script>

<template>
	<div
		v-if="isVisibleAnimation"
		ref="stickyRef"
		class="sticky-booker"
		:style="{ marginBottom: `-${stickyHeight}px` }"
		:data-visible="isVisible"
		:data-topbar-visible="isTopBarVisible">
		<ClientOnly>
			<LazyIdleGlobalBooker nav hydrate-on-idle />
		</ClientOnly>
	</div>
</template>

<style scoped lang="scss" src="./StickyBooker.scss"></style>
